import { render } from "./PaginationBar.vue?vue&type=template&id=7a39bd99"
import script from "./PaginationBar.vue?vue&type=script&lang=js"
export * from "./PaginationBar.vue?vue&type=script&lang=js"

import "./PaginationBar.vue?vue&type=style&index=0&id=7a39bd99&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/PaginationBar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7a39bd99"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7a39bd99', __exports__)) {
    api.reload('7a39bd99', __exports__)
  }
  
  module.hot.accept("./PaginationBar.vue?vue&type=template&id=7a39bd99", () => {
    api.rerender('7a39bd99', render)
  })

}


export default __exports__